<template>
  <div :style="{display: 'flex', flexDirection: 'column', gap: '15px'}" v-if="item">
    <div class="field">
      <div>狀態</div>
      <div>待對帳
        <button v-if="message" @click="$emit('sendMessage')" id="sendTextRemit" class="sendTextMsg">發送簡訊</button>
      </div>
    </div>
    <div class="field">
      <div>付訂方式</div>
      <div>{{item.remitType}}</div>
    </div>
    <div class="field">
      <div>付訂日期</div>
      <div>{{item.transactionDate ? toDateTime(item.transactionDate) : toDateTime(remitTime)}}</div>
    </div>
    <div class="field" v-if="item.AccountInfo">
      <div>付訂資訊</div>
      <div>{{item.AccountInfo}}</div>
    </div>
    <div class="field" v-else-if="item.remitName || item.remit5code">
      <div>付訂資訊</div>
      <div>{{item.remitName || item.remit5code}}</div>
    </div>
    <div class="field">
      <div>訂金金額</div>
      <div><span class="highlight">{{formatDollarInt(item.remitAmount)}}</span> 元</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item', 'remitTime', 'other', 'message']

}
</script>

<style lang="scss" scoped>
#sendTextRemit {
  margin-left: auto;
  background-color: var(--color-checked);
  color: #FFFFFF;
  padding: .1em .5em;
  border-radius: 3px;
}
.field {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 28px;
  &.field-edit {
    line-height: 35px;
  }
  &>:nth-child(1) {
    text-align: end;
  }
  &>:nth-child(2) {
    text-align: start;
    display: flex;
    align-items: center;
  }
  .inputtext {
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    text-align: start;
    align-items: center;
    max-width: 220px;
    &::-webkit-scrollbar {
      height: 0;
    }
  }
}
</style>
